import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import FormTextArea from "../../components/formFields/FormTextArea";
import { clearWorkCultureDetails } from "./workCultureSlice";
import {
  createWorkCulture,
  getAllWorkCulture,
  getWorkCultureByID,
  updateWorkCulture,
} from "./services/workCulture.services";

const CreateWorkCulture: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const WorkCultureDetail = useAppSelector(
    (state) => state.workculture.WorkCultureDetail
  );
  const WorkCultureID = useAppSelector((state) => state.muidrawer.data);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [WorkCultureDetail]);

  const loading = useAppSelector((state) => state.workculture.formloading);

  useEffect(() => {
    return () => {
      dispatch(clearWorkCultureDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (WorkCultureID) {
      dispatch(getWorkCultureByID(WorkCultureID));
    }
  }, [WorkCultureID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!WorkCultureID) {
        const insertPayload = {
          Title: values.Title ?? "",
          Description: values.Description ?? "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createWorkCulture(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearWorkCultureDetails());
          dispatch(getAllWorkCulture());
        }
      } else {
        const editPayload = {
          ID: WorkCultureID,
          Title: values.Title ?? "",
          Description: values.Description ?? "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateWorkCulture(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearWorkCultureDetails());
          dispatch(getAllWorkCulture());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        initialValues={WorkCultureDetail}
        key={formKey}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              gap={{ rows: 10 }}
              cols={[{ width: "100%" }]}
            >
              <GridLayoutItem
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <Typography.h4 className="m-0">
                  {WorkCultureID ? "Update Work Culture" : "Add Work Culture"}
                </Typography.h4>
                <Button
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                >
                  <RxCross1 />
                </Button>
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  id={"Title"}
                  name={"Title"}
                  label={"Title"}
                  placeholder={"Title"}
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  wrapperClassName="right-aligned-field"
                  name="Description"
                  label="Description"
                  placeholder="Description"
                  component={FormTextArea}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  id={"IsActive"}
                  name={"IsActive"}
                  label={"Status"}
                  component={FormSelectionField}
                  validator={requiredValidator}
                  astrike={true}
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status.value,
                      label: status.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem
                colSpan={3}
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={WorkCultureID ? "Update" : "Create"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />

                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateWorkCulture;
